<template>
    <div v-if="!allCompleted" class="px-3 pb-2 text-center bg-zinc-50">
        
        <p class="px-2 py-2 text-xs ">Complete your profile:</p>
        <div class="w-full bg-gray-200 rounded-full min-h-3 dark:bg-gray-700">
            <a href="/profile-settings/basics" class="w-full bg-gray-200 rounded-full min-h-3 dark:bg-gray-700" style="cursor: pointer;">
                <div class="bg-clay-600 text-xs font-medium text-clay-100 text-center p-0.5 leading-none rounded-full" :style="{ width: percentCompleted + '%' }">{{ percentCompleted }}%</div>
            </a>
        </div>

        <div hidden="hidden">
            <div v-for="section in sections" :key="section.name" class="py-1" role="none">
                <a v-if="tags.includes(section.tag)"
                   id="menu-item-0"
                   :href="section.url" class="flex items-center px-4 py-2 text-sm font-semibold text-gray-900 group"
                   role="menuitem" tabindex="-1">
                    <CheckCircleIcon class="w-5 h-5 mr-3 text-powder-600"></CheckCircleIcon>
                    {{ section.name }}
                </a>
                <a v-else
                   id="menu-item-0"
                   :href="section.url" class="flex items-center px-4 py-2 text-sm text-gray-900 group" role="menuitem"
                   tabindex="-1">
                    <CheckCircleIcon class="w-5 h-5 mr-3 text-gray-300 group-hover:text-clay-800"></CheckCircleIcon>
                    {{ section.name }}
                </a>
            </div>
            
        </div>
        
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps, onMounted, ref, Ref} from "vue";
import {store} from "@/store";
import {CheckCircleIcon} from '@heroicons/vue/20/solid';
import _ from 'lodash';
import {client} from "@/shared";
import {GetUserMetadata, UserMetadata} from "@/dtos";

const tags = ref([]);
const sections = ref([]);

const allCompleted = computed(() => {
    let sectionTags: any[] = [];
    sections.value.forEach((section: any) => {
        sectionTags.push(section.tag);
    })
    return _.difference(sectionTags, tags.value).length === 0;
});

const completedTags = computed(() => {
    let sectionTags: any[] = [];
    sections.value.forEach((section: any) => {
        sectionTags.push(section.tag);
    })
    let notCompleted = _.difference(sectionTags, tags.value).length;
    let completed = 7 - notCompleted;
    return completed;
});

const percentCompleted = computed(() => Math.floor((completedTags.value * 100) / 7));

onMounted(async () => {
    sections.value = store.profileProgressSection;

    await client.get<UserMetadata>(new GetUserMetadata())
        .then(response => {
            tags.value = response.tags;
        });

});
</script>